import { useContext, useEffect, useRef, useState } from "react";
import {
	deleteMessage,
	getAllTemplates,
	getDirections,
	getMessages,
	getTemplateById,
	sendMessage,
	sendRead,
	updateMessage,
} from "./Api";
import { MessagesContext } from "../Context/MessagesContext";
import { usePrsInfo } from "./effects";
import DeleteIcon from "../Icons/DeleteIcon";

function MessagesWidget({
	activeContact,
	inputRef,
	setInputBoxVisible,
	setActiveContact,
}) {
	const [directions, setDirections] = useState({});
	const { messages, setMessages, inputBoxVisible } =
		useContext(MessagesContext);
	const messagesUpdate = () =>
		getMessages().then((res) =>
			setMessages((prev) => {
				let prevInput = prev.filter((message) => message.direction === 0);
				let resInput = res.filter((message) => message.direction === 0);
				if (prevInput.length < resInput.length && prevInput.length !== 0) {
					let lastMessage = resInput.findLast((item) => item.direction === 0);
					let notification = new Notification(lastMessage.alias, {
						body: "Получено новое сообщение",
					});
					notification.addEventListener("click", () => {
						window.focus();
						if (lastMessage) {
							setActiveContact(lastMessage.contact_id);
						}
					});
				}
				return res;
			})
		);

	useEffect(() => {
		getDirections().then((res) => setDirections(res));
		messagesUpdate();
		let intervalId = setInterval(() => {
			messagesUpdate();
		}, 2000);
		return () => {
			clearInterval(intervalId);
		};
	}, []);
	return (
		<div className='messages-widget'>
			{inputBoxVisible ? (
				<MessageSender
					activeContact={activeContact}
					messagesUpdate={messagesUpdate}
					inputRef={inputRef}
					setInputBoxVisible={setInputBoxVisible}
				/>
			) : null}
			<MessagesWindow
				messages={messages
					.filter((i) => i.contact_id === activeContact)
					.reverse()}
				directions={directions}
				messagesUpdate={messagesUpdate}
			/>
		</div>
	);
}

export default MessagesWidget;

const MessagesWindow = ({ messages, directions, messagesUpdate }) => {
	const prsInfo = usePrsInfo();
	const templates = useTemplates();
	console.log(messages);
	function isJsonString(str) {
		try {
			let t = JSON.parse(str);
			if (typeof t === "object") {
				return true;
			}
		} catch (e) {
			return false;
		}
		return false;
	}
	const prepareMessage = (message) => {
		if (isJsonString(message)) {
			let messageObject = JSON.parse(message);
			let template = [];
			if (messageObject?.templateId) {
				const templateJson = templates.find(
					(temp) => temp.ID === messageObject?.templateId
				);
				template = JSON.parse(templateJson.PATT_JSON).Fields;
			}
			const instruction = () => {
				let strings = template.find((item) => item.Strings)?.Strings ?? [];
				return strings.map((s) => <div>{s}</div>);
			};
			return (
				<div className='message-template'>
					<h2>{messageObject.templateName}</h2>
					{instruction()}
					{Object.keys(messageObject?.data ?? {}).map((key) => {
						const label =
							template.find((item) => item.Name === key)?.Label ?? key;
						const width =
							template.find((item) => item.Name === key)?.Width ?? "1";
						return (
							<div
								className='message-template-row'
								style={
									width === "1"
										? { width: "98%" }
										: width === "1/2"
										? { width: "49%" }
										: { width: "32.65%" }
								}
							>
								<div className='message-template-row-title'>{`${label}: `}</div>
								<div className='message-template-row-value'>
									{typeof messageObject.data[key] === "object"
										? ""
										: ` ${messageObject?.data[key]}`}
								</div>
							</div>
						);
					})}
				</div>
			);
		} else {
			return message;
		}
	};
	return (
		<div className='messages-window'>
			{messages
				.sort((a, b) => b.datetime - a.datetime)
				.map((message, i) => (
					<div
						key={i}
						// style={
						// 	message.direction === directions.Outgoing
						// 		? { marginRight: "0px", marginLeft: "auto" }
						// 		: null
						// }
					>
						<div className='message-bubble'>
							<div className='title'>
								<div className='left-side'>
									<div>
										{message.direction === 0
											? message.alias
											: prsInfo.prs_alias}
										,
									</div>
									<div>
										{`отправлено: ${new Date(
											message.datetime * 1000
										).toLocaleString()}`}
									</div>
									<div>{` прочтено: ${
										message.datetime_read === 0
											? "XX.XX.XXXX XX:XX:XX"
											: new Date(message.datetime_read * 1000).toLocaleString()
									}`}</div>
									{message.datetime_read === 0 && message.direction === 0 ? (
										<button
											className='expend-button'
											onClick={() => {
												// updateMessage(message.uid).then(() => {
												// 	messagesUpdate();
												// });
												sendRead(message.contact_id, message.uid).then(() => {
													messagesUpdate();
												});
											}}
										>
											Развернуть
										</button>
									) : null}
								</div>
								<div className='right-side'>
									<div>
										<DeleteIcon
											className={"delete-message"}
											width={2}
											height={2}
											tooltip={"Удалить"}
											func={() => {
												deleteMessage(message.message_id);
												messagesUpdate();
											}}
										/>
									</div>
								</div>
							</div>
							{message.datetime_read > 0 || message.direction === 1 ? (
								<div className='message-body'>
									{prepareMessage(message.text)}
								</div>
							) : null}
						</div>
					</div>
				))}
		</div>
	);
};

const MessageSender = ({
	activeContact,
	messagesUpdate,
	inputRef,
	setInputBoxVisible,
}) => {
	const { sendDataFlag, setSendDataFlag } = useContext(MessagesContext);
	useEffect(() => {
		if (sendDataFlag) {
			setSendDataFlag(false);
			send();
		}
	}, [sendDataFlag]);
	useEffect(() => {
		if (activeContact === null) {
			inputRef.current.value = "";
			setInputBoxVisible(false);
		}
	}, [activeContact]);
	const send = () => {
		if (inputRef.current.value === "") {
			return;
		}
		sendMessage(activeContact, inputRef.current.value).then(() => {
			messagesUpdate();
			inputRef.current.value = "";
			setInputBoxVisible((prev) => false);
		});
	};
	return (
		<div
			className='message-sender'
			style={
				activeContact === null ? { pointerEvents: "none", opacity: 0.4 } : null
			}
		>
			<textarea
				// onKeyDown={(e) => {
				// 	if (e.key == "Enter") {
				// 		send();
				// 	}
				// }}
				ref={inputRef}
				placeholder='Введите сообщение...'
			/>
			{/* <button onClick={send}>»</button> */}
		</div>
	);
};

const useTemplates = () => {
	const [templates, setTemplates] = useState([]);
	useEffect(() => {
		getAllTemplates().then((res) => setTemplates(res));
	}, []);
	return templates;
};
